import {
  Checkbox,
  Divider,
  Link,
  LinkButton,
  Space,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { useContext } from "react";
import { Trans, useTranslation } from "react-i18next";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import { CollapsibleCardContext } from "../layouts/CollapsibleCardLayout";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function ComplianceCheckboxControl(props: CascadiaControlProps) {
  const { t } = useTranslation();
  const { options } = props;
  const { isCollapsed, setIsCollapsed } = useContext(CollapsibleCardContext);

  const { isSummary } = useContext(CascadiaJsonFormContext);
  if (isSummary) {
    if (options?.include_summary === false) {
      return null;
    }
    return <SummaryItem label={props.label}>{String(props.data)}</SummaryItem>;
  }

  if (!options.legal_act_url || !options.legal_act_name) {
    return <></>;
  }

  return (
    <>
      <Checkbox
        description={props.description}
        errors={props.errors}
        id={props.id}
        isCard={options.card}
        isDisabled={!props.enabled}
        isInvalid={props.invalid}
        isRequired={props.required}
        isSelected={props.data}
        name={props.path}
        onBlur={props.setTouched}
        onChange={(value) => {
          props.setValue(value);
          props.setTouched();
          if (setIsCollapsed) setIsCollapsed(!value);
        }}
        testID={`compliance-${slugify(props.label)}-checkbox`}
      >
        <Trans>
          The credit report has been requested in accordance with{" "}
          <Link
            linkStyle="monochrome"
            textColor="text-weak"
            href={options.legal_act_url}
            testID="compliance-legal-act-link"
            target="_blank"
          >
            {options.legal_act_name}
          </Link>
          .
        </Trans>
      </Checkbox>
      <Space />
      {setIsCollapsed && props.data && isCollapsed && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <LinkButton
            textColor="text-weak"
            textStyle="form/body-primary-link"
            testID={
              "edit-" +
              slugify(props.label.replace("?", "")) +
              "-compliance-checkbox-control"
            }
            linkStyle="monochrome"
            onPress={() => {
              setIsCollapsed(false);
            }}
          >
            {t("Edit")}
          </LinkButton>
          <Divider isVertical borderLeftColor="border-base" />
        </div>
      )}
    </>
  );
}

ComplianceCheckboxControl.displayName = "ComplianceCheckboxControl";

export const ComplianceCheckboxRenderer = withCascadiaControlProps(
  ComplianceCheckboxControl
);
